import type { XY } from "../shared/types"

export const dot = (a: XY, b: XY) => a.x * b.x + a.y * b.y
